/*=========================================================================================
  File Name: modulePackageManagementMutations.js
  Description: Package Module Mutations
==========================================================================================*/

export default {

  REGISTER_PACKAGES() {

  },

  SYNC_PACKAGES() {

  },

  SET_PACKAGES(state, packages) {
    state.packages = packages
  },

  UPDATE_PACKAGE(state, data) {
    //Find the package and update it
    var pkgs = state.packages
    var item = pkgs.find(p => p.id == data.id);

    if (item) {
      var idx = pkgs.indexOf(item);
      pkgs.splice(idx, 1, data);
      state.packages = pkgs
    }
  },
}
